export const ZONE_JUST_GET_HOOK = '_$$_';

